import { IconFileText, IconFileTypePdf } from '@tabler/icons-react';
import { Attachment } from '@medplum/fhirtypes';

export function AttachmentFileIcon({ attachment }: { attachment: Attachment }) {
  if (attachment?.contentType === 'application/pdf') {
    return <IconFileTypePdf size={16} color="var(--mantine-color-blue-6)" />;
  }

  return <IconFileText size={16} color="var(--mantine-color-blue-6)" />;
}
